<template>
  <div>
    <el-form label-position="top"
             :inline="true">
      <el-row class="row-mar-l">
        <el-col :span="6">
          <!-- 中文名称 -->
          <el-form-item :label="$t('calendar.nameCn')"
                        prop="nameCn">
            <el-input v-model="dataForm.nameCn"
                      :placeholder="$t('user.input')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 英文名称 -->
          <el-form-item :label="$t('calendar.nameEn')"
                        prop="nameEn">
            <el-input v-model="dataForm.nameEn"
                      :placeholder="$t('user.input')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 开始时间 -->
          <el-form-item :label="$t('dimission.startData')">
            <el-date-picker v-model="dataForm.startTime"
                            type="date"
                            :placeholder="$t('user.select')"
                            @change="dateStartTime(dataForm.startTime)">
            </el-date-picker>
            <!-- <el-input v-model="dataForm.startTime"></el-input> -->
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 结束时间 -->
          <el-form-item :label="$t('dimission.endData')">
            <el-date-picker v-model="dataForm.endTime"
                            type="date"
                             @change="dateEndTime(dataForm.endTime)"
                            :placeholder="$t('user.select')">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div>
      <el-button type="primary" @click="lastYearHandle()">上一年</el-button>
      <el-button type="primary" @click="nextYearHandle()">下一年</el-button>
      <el-button type="primary" @click="saveHandle()">保存</el-button>
    </div>
    <ul>
      <!-- 1月 -->
      <li class="month">
        <div class="main">
          <div class="choose_year">
            <div class="date">{{year}}.1月</div>
          </div>
          <div class="days_area">
            <div class="day week" v-for="week in weeks" :key="week">{{week}}</div>
            <div :class="`day ${year}01${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"
                 v-for="(day, index) in days"
                 :key="index">
              <p>{{day.gregorian}}</p>
              <span :class="`holiday event${year}01${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"></span>
            </div>
          </div>
        </div>
      </li>
      <!-- 2月 -->
      <li class="month">
        <div class="main">
          <div class="choose_year">
            <div class="date">{{year}}.2月</div>
          </div>
          <div class="days_area">
            <div class="day week" v-for="week in weeks" :key="week">{{week}}</div>
            <div :class="`day ${year}02${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"
                 v-for="(day, index) in daysTwo"
                 :key="index">
              <p>{{day.gregorian}}</p>
              <span :class="`holiday event${year}02${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"></span>
            </div>
          </div>
        </div>
      </li>
      <!-- 3月 -->
      <li class="month">
        <div class="main">
          <div class="choose_year">
            <div class="date">{{year}}.3月</div>
          </div>
          <div class="days_area">
            <div class="day week" v-for="week in weeks" :key="week">{{week}}</div>
            <div :class="`day ${year}03${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"
                 v-for="(day, index) in daysThree"
                 :key="index">
              <p>{{day.gregorian}}</p>
              <span :class="`holiday event${year}03${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"></span>
            </div>
          </div>
        </div>
      </li>
      <!-- 4月 -->
      <li class="month">
        <div class="main">
          <div class="choose_year">
            <div class="date">{{year}}.4月</div>
          </div>
          <div class="days_area">
            <div class="day week" v-for="week in weeks" :key="week">{{week}}</div>
            <div :class="`day ${year}04${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"
                 v-for="(day, index) in daysFour"
                 :key="index">
              <p>{{day.gregorian}}</p>
              <span :class="`holiday event${year}04${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"></span>
            </div>
          </div>
        </div>
      </li>
      <!-- 5月 -->
      <li class="month">
        <div class="main">
          <div class="choose_year">
            <div class="date">{{year}}.5月</div>
          </div>
          <div class="days_area">
            <div class="day week" v-for="week in weeks" :key="week">{{week}}</div>
            <div :class="`day ${year}05${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"
                 v-for="(day, index) in daysFifve"
                 :key="index">
              <p>{{day.gregorian}}</p>
              <span :class="`holiday event${year}05${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"></span>
            </div>
          </div>
        </div>
      </li>
      <!-- 6月 -->
      <li class="month">
        <div class="main">
          <div class="choose_year">
            <div class="date">{{year}}.6月</div>
          </div>
          <div class="days_area">
            <div class="day week" v-for="week in weeks" :key="week">{{week}}</div>
            <div :class="`day ${year}06${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"
                 v-for="(day, index) in daysSix"
                 :key="index">
              <p>{{day.gregorian}}</p>
              <span :class="`holiday event${year}06${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"></span>
            </div>
          </div>
        </div>
      </li>
      <!-- 7月 -->
      <li class="month">
        <div class="main">
          <div class="choose_year">
            <div class="date">{{year}}.7月</div>
          </div>
          <div class="days_area">
            <div class="day week" v-for="week in weeks" :key="week">{{week}}</div>
            <div :class="`day ${year}07${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"
                 v-for="(day, index) in daysSeven"
                 :key="index">
              <p>{{day.gregorian}}</p>
              <span :class="`holiday event${year}07${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"></span>
            </div>
          </div>
        </div>
      </li>
      <!-- 8月 -->
      <li class="month">
        <div class="main">
          <div class="choose_year">
            <div class="date">{{year}}.8月</div>
          </div>
          <div class="days_area">
            <div class="day week" v-for="week in weeks" :key="week">{{week}}</div>
            <div :class="`day ${year}08${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"
                 v-for="(day, index) in daysEight"
                 :key="index">
              <p>{{day.gregorian}}</p>
              <span :class="`holiday event${year}08${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"></span>
            </div>
          </div>
        </div>
      </li>
      <!-- 9月 -->
      <li class="month">
        <div class="main">
          <div class="choose_year">
            <div class="date">{{year}}.9月</div>
          </div>
          <div class="days_area">
            <div class="day week" v-for="week in weeks" :key="week">{{week}}</div>
            <div :class="`day ${year}09${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"
                 v-for="(day, index) in daysNine"
                 :key="index">
              <p>{{day.gregorian}}</p>
              <span :class="`holiday event${year}09${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"></span>
            </div>
          </div>
        </div>
      </li>
      <!-- 10月 -->
      <li class="month">
        <div class="main">
          <div class="choose_year">
            <div class="date">{{year}}.10月</div>
          </div>
          <div class="days_area">
            <div class="day week" v-for="week in weeks" :key="week">{{week}}</div>
            <div :class="`day ${year}10${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"
                 v-for="(day, index) in daysTen"
                 :key="index">
              <p>{{day.gregorian}}</p>
              <span :class="`holiday event${year}10${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"></span>
            </div>
          </div>
        </div>
      </li>
       <!-- 11月 -->
      <li class="month">
        <div class="main">
          <div class="choose_year">
            <div class="date">{{year}}.11月</div>
          </div>
          <div class="days_area">
            <div class="day week" v-for="week in weeks" :key="week">{{week}}</div>
            <div :class="`day ${year}11${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"
                 v-for="(day, index) in daysEleven"
                 :key="index">
              <p>{{day.gregorian}}</p>
              <span :class="`holiday event${year}11${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"></span>
            </div>
          </div>
        </div>
      </li>
       <!-- 12月 -->
      <li class="month">
        <div class="main">
          <div class="choose_year">
            <div class="date">{{year}}.12月</div>
          </div>
          <div class="days_area">
            <div class="day week" v-for="week in weeks" :key="week">{{week}}</div>
            <div :class="`day ${year}12${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"
                 v-for="(day, index) in daysTwelve"
                 :key="index">
              <p>{{day.gregorian}}</p>
              <span :class="`holiday event${year}12${(day.gregorian >= 10) ? day.gregorian : ('0' + day.gregorian)}`"></span>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import $ from 'jquery'
export default {
  name: 'calendar',
  data () {
    return {
      dataForm: [],
      isdate: true,
      year: 0,
      month: 0,
      today: 0,
      days: [],
      daysTwo: [],
      daysThree: [],
      daysFour: [],
      daysFifve: [],
      daysSix: [],
      daysSeven: [],
      daysEight: [],
      daysNine: [],
      daysTen: [],
      daysEleven: [],
      daysTwelve: [],
      weeks: ['一', '二', '三', '四', '五', '六', '日'],
      startTime: '',
      endTime: ''
    }
  },
  mounted () {
    const now = new Date()
    this.year = now.getFullYear()
    this.month = now.getMonth() + 1
    this.today = now.getDate()
    this.getDays()
    this.getDaysTwo()
    this.getDaysThree()
    this.getDaysFour()
    this.getDaysFifve()
    this.getDaysSix()
    this.getDaysSeven()
    this.getDaysEigeht()
    this.getDaysNine()
    this.getDaysTen()
    this.getDaysEleven()
    this.getDaysTwelve()
  },
  methods: {
    getDays () { // 获取1月份所有公历日期
      this.days = []
      const time = new Date()
      time.setFullYear(this.year, 0, 0)
      for (let i = 0; i < time.getDay(); i++) {
        this.days.push({ gregorian: '' })
      }
      console.log(this.days)
      const timeNextmonth = new Date()
      timeNextmonth.setFullYear(this.year, 1, 0)
      for (let i = 1; i <= timeNextmonth.getDate(); i++) {
        this.days.push({ gregorian: i })
      }
    },
    getDaysTwo () { // 获取2月份所有公历日期
      this.daysTwo = []
      const timeTwo = new Date()
      timeTwo.setFullYear(this.year, 1, 0)
      for (let i = 0; i < timeTwo.getDay(); i++) {
        this.daysTwo.push({ gregorian: '' })
      }
      console.log(timeTwo)
      const timeTwoNextmonth = new Date()
      timeTwoNextmonth.setFullYear(this.year, 2, 0)
      for (let i = 1; i <= timeTwoNextmonth.getDate(); i++) {
        this.daysTwo.push({ gregorian: i })
      }
    },
    getDaysThree () { // 获取三月份所有日期
      this.daysThree = []
      const timeThree = new Date()
      timeThree.setFullYear(this.year, 2, 0)
      for (let i = 0; i < timeThree.getDay(); i++) {
        this.daysThree.push({ gregorian: '' })
      }
      const timeThreeNextmonth = new Date()
      timeThreeNextmonth.setFullYear(this.year, 3, 0)
      for (let i = 1; i <= timeThreeNextmonth.getDate(); i++) {
        this.daysThree.push({ gregorian: i })
      }
    },
    getDaysFour () { // 获取四月份所有日期
      this.daysFour = []
      const timeFour = new Date()
      timeFour.setFullYear(this.year, 3, 0)
      for (let i = 0; i < timeFour.getDay(); i++) {
        this.daysFour.push({ gregorian: '' })
      }
      const timeFourNextmonth = new Date()
      timeFourNextmonth.setFullYear(this.year, 4, 0)
      for (let i = 1; i <= timeFourNextmonth.getDate(); i++) {
        this.daysFour.push({ gregorian: i })
      }
    },
    getDaysFifve () { // 获取五月份所有日期
      this.daysFifve = []
      const timeFifve = new Date()
      timeFifve.setFullYear(this.year, 4, 0)
      for (let i = 0; i < timeFifve.getDay(); i++) {
        this.daysFifve.push({ gregorian: '' })
      }
      const timeFifveNextmonth = new Date()
      timeFifveNextmonth.setFullYear(this.year, 5, 0)
      for (let i = 1; i <= timeFifveNextmonth.getDate(); i++) {
        this.daysFifve.push({ gregorian: i })
      }
    },
    getDaysSix () { // 获取六月份所有日期
      this.daysSix = []
      const timeSix = new Date()
      timeSix.setFullYear(this.year, 5, 0)
      for (let i = 0; i < timeSix.getDay(); i++) {
        this.daysSix.push({ gregorian: '' })
      }
      const timeSixNextmonth = new Date()
      timeSixNextmonth.setFullYear(this.year, 6, 0)
      for (let i = 1; i <= timeSixNextmonth.getDate(); i++) {
        this.daysSix.push({ gregorian: i })
      }
    },
    getDaysSeven () { // 获取七月份所有日期
      this.daysSeven = []
      const timeSeven = new Date()
      timeSeven.setFullYear(this.year, 6, 0)
      for (let i = 0; i < timeSeven.getDay(); i++) {
        this.daysSeven.push({ gregorian: '' })
      }
      const timeSevenNextmonth = new Date()
      timeSevenNextmonth.setFullYear(this.year, 7, 0)
      for (let i = 1; i <= timeSevenNextmonth.getDate(); i++) {
        this.daysSeven.push({ gregorian: i })
      }
    },
    getDaysEigeht () { // 获取八月份所有日期
      this.daysEight = []
      const timeEight = new Date()
      timeEight.setFullYear(this.year, 7, 0)
      for (let i = 0; i < timeEight.getDay(); i++) {
        this.daysEight.push({ gregorian: '' })
      }
      const timeEightNextmonth = new Date()
      timeEightNextmonth.setFullYear(this.year, 8, 0)
      for (let i = 1; i <= timeEightNextmonth.getDate(); i++) {
        this.daysEight.push({ gregorian: i })
      }
    },
    getDaysNine () { // 获取九月份所有日期
      this.daysNine = []
      const timeNine = new Date()
      timeNine.setFullYear(this.year, 8, 0)
      for (let i = 0; i < timeNine.getDay(); i++) {
        this.daysNine.push({ gregorian: '' })
      }
      const timeNineNextmonth = new Date()
      timeNineNextmonth.setFullYear(this.year, 9, 0)
      for (let i = 1; i <= timeNineNextmonth.getDate(); i++) {
        this.daysNine.push({ gregorian: i })
      }
    },
    getDaysTen () { // 获取十月份所有日期
      this.daysTen = []
      const timeTen = new Date()
      timeTen.setFullYear(this.year, 9, 0)
      for (let i = 0; i < timeTen.getDay(); i++) {
        this.daysTen.push({ gregorian: '' })
      }
      const timeTenNextmonth = new Date()
      timeTenNextmonth.setFullYear(this.year, 10, 0)
      for (let i = 1; i <= timeTenNextmonth.getDate(); i++) {
        this.daysTen.push({ gregorian: i })
      }
    },
    getDaysEleven () { // 获取十一月份所有日期
      this.daysEleven = []
      const timeEleven = new Date()
      timeEleven.setFullYear(this.year, 10, 0)
      for (let i = 0; i < timeEleven.getDay(); i++) {
        this.daysEleven.push({ gregorian: '' })
      }
      const timeElevenNextmonth = new Date()
      timeElevenNextmonth.setFullYear(this.year, 11, 0)
      for (let i = 1; i <= timeElevenNextmonth.getDate(); i++) {
        this.daysEleven.push({ gregorian: i })
      }
    },
    getDaysTwelve () { // 获取十一月份所有日期
      this.daysTwelve = []
      const timeTwelve = new Date()
      timeTwelve.setFullYear(this.year, 11, 0)
      for (let i = 0; i < timeTwelve.getDay(); i++) {
        this.daysTwelve.push({ gregorian: '' })
      }
      const timeTwelveNextmonth = new Date()
      timeTwelveNextmonth.setFullYear(this.year + 1, 0, 0)
      for (let i = 1; i <= timeTwelveNextmonth.getDate(); i++) {
        this.daysTwelve.push({ gregorian: i })
      }
    },
    // 上一年
    lastYearHandle () {
      this.year -= 1
      this.getDays()
      this.getDaysTwo()
      this.getDaysThree()
      this.getDaysFour()
      this.getDaysFifve()
      this.getDaysSix()
      this.getDaysSeven()
      this.getDaysEigeht()
      this.getDaysNine()
      this.getDaysTen()
      this.getDaysEleven()
      this.getDaysTwelve()
    },
    // 下一年
    nextYearHandle () {
      this.year += 1
      this.getDays()
      this.getDaysTwo()
      this.getDaysThree()
      this.getDaysFour()
      this.getDaysFifve()
      this.getDaysSix()
      this.getDaysSeven()
      this.getDaysEigeht()
      this.getDaysNine()
      this.getDaysTen()
      this.getDaysEleven()
      this.getDaysTwelve()
    },
    // 获取假期的初始值
    dateStartTime (date) {
      if (date !== '' && date !== null && date !== undefined) {
        this.startTime = `${date.getFullYear()}${((date.getMonth() + 1) >= 10) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))}${(date.getDate() >= 10) ? date.getDate() : '0' + date.getDate()}`
      }
      console.log(this.startTime)
      // $(`.${this.startTime}`).css({
      //   'background-color': 'blue'
      // })
      // if (this.endTime !== '' && this.endTime !== null && this.endTime !== undefined) {
      //   for (let i = this.startTime; i <= this.endTime; i++) {
      //     $(`.${i}`).css({
      //       'background-color': 'blue'
      //     })
      //   }
      // }
    },
    // 获取假期的末尾值
    dateEndTime (date) {
      if (date !== '' && date !== null && date !== undefined) {
        this.endTime = `${date.getFullYear()}${((date.getMonth() + 1) >= 10) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))}${(date.getDate() >= 10) ? date.getDate() : '0' + date.getDate()}`
      }
      console.log(this.endTime)
      // $(`.${this.endTime}`).css({
      //   'background-color': 'blue'
      // })
      // if (this.startTime !== '' && this.startTime !== null && this.startTime !== undefined) {
      //   for (let i = this.startTime; i <= this.endTime; i++) {
      //     $(`.${i}`).css({
      //       'background-color': 'blue'
      //     })
      //   }
      // }
    },
    // 保存
    saveHandle () {
      if (this.startTime !== '' && this.startTime !== null && this.startTime !== undefined && this.endTime !== '' && this.endTime !== null && this.endTime !== undefined) {
        for (let i = this.startTime; i <= this.endTime; i++) {
          $(`.${i}`).css({
            'background-color': 'blue'
          })
        }
      }
      if (this.startTime !== '' && this.startTime !== null && this.startTime !== undefined && this.endTime !== '' && this.endTime !== null && this.endTime !== undefined) {
        $((`.event${this.startTime}`)).html(this.dataForm.nameCn)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  ul{
    width: 100%;
    margin: 0;
    padding: 0;
  }
  .month{
    float: left;
    list-style: none;
    width: 24%;
    height: 270px;
    margin-left: 1%;
    background: #ccc;
    margin-top: 10px;
  }
  .main{
    .choose_year{
      display: flex;
      .icon{
        width: 10%;
        // height: 8vh;
        // line-height: 8vh;
        text-align: center;
      }
      .date{
        width: 60%;
        text-align: center;
        // height: 8vh;
        // line-height: 8vh;
        font-size: 1.2rem;
      }
      .holiday{
        white-space:nowrap;
      }
    }
    .days_area{
      display: flex;
      flex-wrap: wrap;
      .day{
        width: 14.28%;
        text-align: center;
        padding: 1vh 0;
        margin-top: 1vh;
        p{
          margin: 0;
          // font-size: 6vw;
        }
      }
      .week{
        background-color: dodgerblue;
        color: #fff;
        font-weight: bold;
        // height: 6vh;
        // line-height: 4vh;
        margin: 0;
      }
      .choose_day{
        background-color: dodgerblue;
        color: #fff;
        font-weight: bold;
      }
    }
  }
</style>
